import UserList from '../../views-admin/User/UserList';
import UserTypeList from '../../views-admin/User/UserTypeList';
import SearchBar from '../../components/SearchBar';

export default [
    {
        path: '/usuarios',
        name: 'user.list',
        component: UserList,
        meta: {
            pageTitle: 'Usuários',
            searchBar: SearchBar,
            breadcrumb: [
                { label: 'Usuários' },
            ],
        },
    },
    {
        path: '/usuarios/tipos',
        name: 'user-type.list',
        component: UserTypeList,
        meta: {
            pageTitle: 'Tipo de Usuário',
            breadcrumb: [
                { label: 'Tipo de Usuário' },
            ],
        },
    },
];
